export const esTranslations = {
  qe: {
    title: 'Inscripción Rápida',
    intro: 'Deberá completar esta inscripción en una sola sesión; su información no se puede guardar a menos que todos los campos estén completados.',
    language_label: 'Idioma',
    sections: {
      personal_info: 'Información Personal',
      personal_address: 'Dirección Personal',
      company_info: 'Información de la Empresa',
      dependent_info: 'Información del Dependiente',
      plan_selection: 'Selección de Plan',
      payment_method: 'Método de Pago',
      saved_payment: 'Método de Pago Guardado',
      summary: 'Resumen',
      required_documents: 'Documentos Requeridos',
      required_documents_subtitle: 'Por favor suba los documentos requeridos listados a continuación.',
    },
    labels: {
      email: 'Correo Electrónico:',
      dob: 'Fecha de Nacimiento:',
      ssn: 'NSS:',
      first_name: 'Nombre:',
      middle_name: 'Segundo Nombre:',
      last_name: 'Apellido:',
      suffix: 'Sufijo:',
      gender: 'Género:',
      marital_status: 'Estado Civil:',
      mobile_phone: 'Teléfono Móvil:',
      confirm_email: 'Confirmar Correo Electrónico:',
      tobacco: '¿La persona usa tabaco?',
      employee_id: 'ID de Empleado:',
      payroll_contact_name: 'Nombre del Contacto de Nómina:',
      payroll_contact_phone: 'Teléfono del Contacto de Nómina:',
      address: 'Dirección:',
      city: 'Ciudad:',
      state: 'Estado:',
      zip_code: 'Código Postal:',
      company_name: 'Nombre de la Empresa:',
      employer_name: 'Nombre del Empleador:',
      ein: 'Número de Identificación del Empleador (EIN):',
      entity_type: 'Tipo de Entidad:',
      billing_email: 'Correo de Facturación:',
      nerds_number: 'Número NERDS',
      association_name: 'Nombre de la Asociación',
      agent_number: 'Número de Agente',
      relation: 'Relación:',
      select_payment_type: 'Seleccione el tipo de pago',
      type_name_here: 'Escriba su nombre aquí:',
      authorization_checkbox:
        'Al marcar la casilla, reconozco que entiendo y acepto la autorización.',
    },
    placeholders: {
      email: 'Correo Electrónico',
      dob: 'Fecha de Nacimiento',
      ssn: 'NSS',
      first_name: 'Nombre',
      middle_name: 'Segundo Nombre',
      last_name: 'Apellido',
      suffix: 'Sufijo',
      gender: 'Género',
      marital_status: 'Estado Civil',
      mobile_phone: 'Teléfono Móvil',
      confirm_email: 'Confirmar Correo Electrónico',
      tobacco: '¿La persona usa tabaco?',
      employee_id: 'ID de Empleado',
      payroll_contact_name: 'Nombre del Contacto de Nómina',
      payroll_contact_phone: 'Teléfono del Contacto de Nómina',
      address: 'Dirección',
      city: 'Ciudad',
      state: 'Estado',
      zip_code: 'Código Postal',
      company_name: 'Nombre de la Empresa',
      employer_name: 'Nombre del Empleador',
      ein: 'Número de Identificación del Empleador (EIN)',
      entity_type: 'Tipo de Entidad',
      billing_email: 'Correo de Facturación',
      nerds_number: 'Número NERDS',
      association_name: 'Nombre de la Asociación',
      agent_number: 'Número de Agente',
      relation: 'Relación',
      signature:
        'Su nombre ingresado en este campo se considerará como su firma electrónica.',
      select_file: 'Seleccionar Archivo',
    },
    options: {
      suffix: 'Sufijo',
      gender: 'Género',
      marital_status: 'Estado Civil',
      entity_type: 'Tipo de Entidad',
      state: 'Estado',
      relation: 'Relación',
      tobacco_yes: 'Sí',
      tobacco_no: 'No',
    },
    buttons: {
      continue: 'Continuar',
      save_select_plans: 'Guardar detalles y seleccionar su(s) plan(es)',
      update_select_plans: 'Actualizar detalles y seleccionar su(s) plan(es)',
      submit: 'Enviar',
      add_family_member: 'Agregar Familiar',
      add_payment: 'Agregar Pago',
      cancel_payment: 'Cancelar',
      select_plan: 'Seleccionar Plan',
      selected_plan: 'Plan Seleccionado',
      waive_coverage: 'Renunciar a la Cobertura',
      coverage_waived: 'Cobertura Renunciada',
      view_benefit_details: 'Ver Detalles del Beneficio',
      benefit_details_header: 'Detalles del Beneficio',
      ok: 'Aceptar',
      close: 'X',
      delete: 'Eliminar',
      restore_spouse: 'Restaurar Cónyuge Eliminado',
      upload: 'Subir',
      reupload: 'Volver a Subir',
      refresh: 'Actualizar',
    },
    coverage: {
      please_select: 'Por favor seleccione',
      myself: 'Yo solo',
      select_tier: 'Por favor seleccione el nivel de cobertura:',
      plan_col_header: 'Nombre',
      enrolled_col_header: 'Selección',
      no_plans_found: 'No se encontraron planes',
      optional_addons: 'Complementos Opcionales',
      dependent_number: 'Dependiente - {{number}}',
      dependent_label: 'Dependiente {{number}}',
    },
    payment: {
      payment_selected: 'Método de pago seleccionado exitosamente.',
      credit_card: 'Tarjeta de Crédito',
      ach: 'ACH',
    },
    summary_table: {
      plan: 'Tipo de Plan',
      enrolled: 'Inscrito',
      employee_contribution: 'Contribución del Empleado',
      total_contribution: 'Contribución Total del Empleado:',
    },
    payment_table: {
      nickname: 'Apodo',
      type: 'Tipo',
      identifier: 'Identificador',
      last_4: 'Últimos 4',
      name: 'Nombre',
      expires_on: 'Vence el',
      account_name: 'Nombre de Cuenta',
      account_number: 'Número de Cuenta',
      routing_number: 'Número de Ruta',
      account_type: 'Tipo de Cuenta',
      entry_method: 'Método de Entrada',
      default: 'Predeterminado',
    },
    otp: {
      code_sent: 'Se ha enviado un código de verificación de 6 dígitos a {{email}}. Ingréselo a continuación para verificar su identidad y continuar.',
    },
    errors: {
      email_required: 'El correo electrónico es obligatorio.',
      valid_email: 'Por favor ingrese un correo electrónico válido.',
      dob_required: 'La fecha de nacimiento es obligatoria.',
      ssn_required: 'El NSS es obligatorio.',
      valid_ssn: 'Por favor ingrese un NSS válido.',
      first_name_required: 'El nombre es obligatorio.',
      last_name_required: 'El apellido es obligatorio.',
      gender_required: 'El género es obligatorio.',
      marital_status_required: 'El estado civil es obligatorio.',
      mobile_phone_required: 'El teléfono móvil es obligatorio.',
      confirm_email_required: 'La confirmación de correo electrónico es obligatoria.',
      valid_confirm_email: 'Por favor ingrese un correo de confirmación válido.',
      tobacco_required: 'El campo de tabaco es obligatorio.',
      address_required: 'La dirección es obligatoria.',
      city_required: 'La ciudad es obligatoria.',
      state_required: 'El estado es obligatorio.',
      zip_required: 'El código postal es obligatorio.',
      valid_zip: 'Ingrese un código postal válido.',
      company_name_required: 'El nombre de la empresa es obligatorio.',
      employer_name_required: 'El nombre del empleador es obligatorio.',
      ein_required: 'El EIN (Número de Identificación del Empleador) es obligatorio.',
      entity_type_required: 'El tipo de entidad es obligatorio.',
      billing_email_required: 'El correo de facturación es obligatorio.',
      valid_billing_email: 'Ingrese un correo de facturación válido.',
      association_name_required: 'El nombre de la asociación es obligatorio.',
      agent_number_required: 'El número de agente es obligatorio.',
      company_street_required: 'La dirección de la empresa es obligatoria.',
      company_city_required: 'La ciudad de la empresa es obligatoria.',
      company_state_required: 'El estado de la empresa es obligatorio.',
      company_zip_required: 'El código postal de la empresa es obligatorio.',
      zip_only_numbers: 'El código postal solo permite valores numéricos.',
      zip_invalid: 'Código postal inválido.',
      relation_required: 'La relación es obligatoria.',
      signature_required: 'El campo de nombre es obligatorio.',
      disclaimer_required: 'Por favor marque el aviso legal.',
      mobile_phone_only_numbers: 'El teléfono móvil solo permite valores numéricos.',
      phone_number_length: 'El número de teléfono debe tener 10 dígitos.',
      payroll_phone_number: 'El teléfono de contacto de nómina debe tener 10 dígitos.',
      email_confirm_not_match: 'La confirmación de correo electrónico no coincide.',
      select_payment_type: 'Seleccione el Tipo de Pago.',
      session_expired: 'Su sesión ha caducado. Vuelva a autenticarse para verificar su identidad y continuar.',
      payment_method_required: 'El método de pago es requerido.',
      multiple_spouse: 'No se pueden seleccionar múltiples cónyuges o pareja doméstica.',
      dependent_ssn_unique: 'El NSS del dependiente debe ser único.',
      plans_not_found: 'No podemos localizar sus planes, por favor contacte a su empleador.',
      select_at_least_one_plan: 'Por favor seleccione al menos un plan.',
      select_plan_type: 'Por favor seleccione un plan de {{planType}}.',
      failed_payment: 'El pago falló debido a {{error}}. Por favor regrese al formulario de inscripción y vuelva a enviarlo.',
      common_error: 'Algo salió mal. Por favor contacte al administrador.',
      valid_credit_card_details: 'Ingrese detalles de tarjeta de crédito válidos.',
      valid_bank_account_details: 'Ingrese detalles de cuenta bancaria válidos.',
      name_on_account_required: 'El nombre en la cuenta es obligatorio.',
      valid_routing_number: 'Ingrese un número de ruta válido.',
      valid_account_number: 'Ingrese un número de cuenta válido.',
      valid_card_number: 'Ingrese un número de tarjeta de crédito válido.',
      valid_card_expiry: 'Ingrese una fecha de vencimiento válida.',
      valid_card_cvv: 'Ingrese un número CVV válido.',
      name_on_card_required: 'El nombre en la tarjeta es obligatorio.',
      invalid_url: 'URL inválida.',
      billing_schedule_error: 'Calendario de facturación inválido. Por favor contacte al administrador.',
      file_required: 'Por favor seleccione un archivo para subir.',
      // IES-5491
      product_not_available_for_tier: 'Este producto no está disponible para el nivel de cobertura "{{tier}}".',
      products_not_available_for_tier: 'Estos productos no están disponibles para el nivel de cobertura "{{tier}}".',
      dependent_relation_not_allowed: 'Los dependientes de tipo {{relation}} no están disponibles para la cobertura de productos de este empleador.',
    },
    modal: {
      failed_payment_title: 'Pago Fallido',
    },
    payment_modal: {
      add_credit_card: 'Agregar Tarjeta de Crédito',
      add_ach: 'Agregar ACH',
      disclaimer_label: 'Aviso Legal:',
      card_number: 'Número de Tarjeta',
      expiration_date: 'Fecha de Vencimiento',
      cvv: 'CVV',
      name_on_card: 'Nombre en la Tarjeta',
      use_current_address: 'Usar mi información de dirección actual',
      first_name: 'Nombre',
      last_name: 'Apellido',
      email: 'Correo Electrónico',
      address: 'Dirección',
      city: 'Ciudad',
      state: 'Estado',
      select_state: 'Seleccionar Estado',
      zip_code: 'Código Postal',
      cancel: 'Cancelar',
      save_information: 'Guardar Información',
      name_on_account: 'Nombre en la Cuenta',
      routing_number: 'Número de Ruta',
      account_number: 'Número de Cuenta',
      account_type: 'Tipo de Cuenta',
      personal_checking: 'Cuenta Corriente Personal',
      personal_savings: 'Cuenta de Ahorros Personal',
      business_checking: 'Cuenta Corriente Empresarial',
      business_savings: 'Cuenta de Ahorros Empresarial',
    },
    success: {
      enrollment_with_payment: 'Gracias por enviar su inscripción. Su pago ha sido enviado exitosamente. Si está pagando mediante ACH (cuenta bancaria), el pago solo se procesará en 4 días hábiles. Si falla, un miembro de nuestro equipo se comunicará con usted por correo electrónico. Espere un correo de bienvenida en las próximas 24 horas con información sobre cómo acceder al portal y los detalles de su plan.',
      enrollment_without_payment: 'Su inscripción está completa y enviada para procesamiento. Gracias.',
    },
  },
  api_values: {
    // Tipos de plan
    medical: 'Médico',
    dental: 'Dental',
    life: 'Vida',
    vision: 'Visión',
    disability: 'Discapacidad',
    accident: 'Accidente',
    critical_illness: 'Enfermedad Crítica',
    std: 'Discapacidad a Corto Plazo',
    ltd: 'Discapacidad a Largo Plazo',
    hospital: 'Hospital',
    ancillary: 'Auxiliar',
    health_share: 'Salud Compartida',
    holistic: 'Holístico',
    hospital_indemnity: 'Indemnización Hospitalaria',
    tobacco: 'Tabaco',
    dpc: 'DPC',
    fee: 'Tarifa',
    mec: 'MEC',
    voluntary_life: 'Vida Voluntaria',
    life_child: 'Vida - Hijo',
    life_spouse: 'Vida - Cónyuge',
    flex: 'FLEX',
    legal: 'LEGAL',
    eap: 'PAE',
    flex_dependent: 'FLEX - Dependiente',
    hsa: 'HSA',
    // Niveles de cobertura — nombres completos
    employee_only: 'Solo Empleado',
    employee_spouse: 'Empleado + Cónyuge',
    employee_children: 'Empleado + Hijos',
    employee_family: 'Empleado + Familia',
    myself: 'Yo solo',
    myself_and_spouse: 'Yo y mi Cónyuge',
    myself_and_children: 'Yo y mis Hijos',
    family: 'Familia',
    // Niveles de cobertura — códigos cortos
    ee: 'Solo Empleado',
    es: 'Empleado + Cónyuge',
    ec: 'Empleado + Hijos',
    ef: 'Empleado + Familia',
    // Categorías de inscripción (resumen)
    self: 'Yo',
    self_spouse: 'Yo+Cónyuge',
    self_child: 'Yo+Hijo',
    // Tipos de pago
    ach: 'ACH',
    cc: 'Tarjeta de Crédito',
    credit_card: 'Tarjeta de Crédito',
    invoice: 'Factura',
    // Tipos de cuenta
    checking: 'Cuenta Corriente',
    savings: 'Cuenta de Ahorros',
    // Métodos de entrada
    manual: 'Manual',
    online: 'En línea',
    swipe: 'Deslizar',
    // Género
    male: 'Masculino',
    female: 'Femenino',
    // Estado civil
    single: 'Soltero/a',
    married: 'Casado/a',
    domestic_partner: 'Pareja Doméstica',
    legally_separated: 'Separado/a Legalmente',
    divorced: 'Divorciado/a',
    widowed: 'Viudo/a',
    // Tipos de entidad
    individual_sole_proprietor_or_single_member_llc: 'Propietario individual o LLC de un solo miembro',
    c_corporation: 'Corporación C',
    s_corporation: 'Corporación S',
    partnership: 'Sociedad',
    trust_estate: 'Fideicomiso/Patrimonio',
    llc_partnership: 'LLC, Sociedad',
    llc_c_corp: 'LLC, Corp C',
    llc_s_corp: 'LLC, Corp S',
    // Relaciones de dependientes
    spouse: 'Cónyuge',
    child: 'Hijo/a',
    disabled_child: 'Hijo/a con Discapacidad',
    // Sufijos de nombre
    sr: 'Sr.',
    jr: 'Jr.',
    i: 'I',
    ii: 'II',
    iii: 'III',
    iv: 'IV',
  },
};
